var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5V9C13 9.79565 13.3161 10.5587 13.8787 11.1213C14.4413 11.6839 15.2044 12 16 12C16.7956 12 17.5587 11.6839 18.1213 11.1213C18.6839 10.5587 19 9.79565 19 9V5H13Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V16",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H18",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27V25L5.438 20.548C5.15469 20.1937 5.00024 19.7536 5 19.3V13.5C5 13.1022 5.15804 12.7206 5.43934 12.4393C5.72064 12.158 6.10218 12 6.5 12V12C6.89782 12 7.27936 12.158 7.56066 12.4393C7.84196 12.7206 8 13.1022 8 13.5V16.586",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26.9999V21.8279C13.9999 21.2976 13.7891 20.7889 13.414 20.4139L10 16.9999C9.73468 16.7349 9.37501 16.5861 9 16.5861C8.62499 16.5861 8.26532 16.7349 8 16.9999V16.9999C7.73498 17.2653 7.58611 17.6249 7.58611 17.9999C7.58611 18.375 7.73498 18.7346 8 18.9999L11 21.9999",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27V25L26.562 20.548C26.8453 20.1937 26.9998 19.7536 27 19.3V13.5C27 13.1022 26.842 12.7206 26.5607 12.4393C26.2794 12.158 25.8978 12 25.5 12V12C25.1022 12 24.7206 12.158 24.4393 12.4393C24.158 12.7206 24 13.1022 24 13.5V16.586",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26.9999V21.8279C18.0001 21.2976 18.2109 20.7889 18.586 20.4139L22 16.9999C22.2653 16.7349 22.625 16.5861 23 16.5861C23.375 16.5861 23.7347 16.7349 24 16.9999V16.9999C24.265 17.2653 24.4139 17.6249 24.4139 17.9999C24.4139 18.375 24.265 18.7346 24 18.9999L21 21.9999",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5H10V7C10 7.79565 10.3161 8.55871 10.8787 9.12132C11.4413 9.68393 12.2044 10 13 10",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5H22V7C22 7.79565 21.6839 8.55871 21.1213 9.12132C20.5587 9.68393 19.7956 10 19 10",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeader);
export default __webpack_public_path__ + "static/media/Leader.5d34da0d896ba2721bc30fbe889c3618.svg";
export { ForwardRef as ReactComponent };